import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import { PatientStatusJourneyApi } from '../../../../../../api';
import { NSPP_PATIENT } from '../../../../../../services/i18n/namespaces';

import ProgressItem from './ProgressItem';

import './PatientStatusProgress.scss';

const PatientStatusProgress = ({ ssuPatientId, progressTrigger, addMissingStatus, displayAddButton }) => {
  const { t } = useTranslation();
  const [progress, setProgress] = useState();

  useEffect(() => {
    if (ssuPatientId) {
      PatientStatusJourneyApi.getStatusJourneyInfo(ssuPatientId).then(({ data }) => {
        setProgress(data);
      });
    }
  }, [ssuPatientId, progressTrigger]);

  return (
    <>
      <div className="status-progress-header">
        <p>{t(`${NSPP_PATIENT}:patientStatusPage.progress`)}</p>
      </div>
      <div className="status-progress-wrapper">
        {progress?.map((item, index) => {
          const dateText = () => {
            if (item.skipped && item.optional) {
              return t(`${NSPP_PATIENT}:patientStatusPage.statusAdditionInfo.missingOptional`);
            } else if (!item.createdAt && item.skipped) {
              return t(`${NSPP_PATIENT}:patientStatusPage.statusAdditionInfo.missing`);
            } else if (!item.createdAt && progress[index - 1]?.current && item.optional) {
              return t(`${NSPP_PATIENT}:patientStatusPage.statusAdditionInfo.nextOptional`);
            } else if (!item.createdAt && progress[index - 1]?.current) {
              return t(`${NSPP_PATIENT}:patientStatusPage.statusAdditionInfo.next`);
            } else if (!item.createdAt && item.optional) {
              return t(`${NSPP_PATIENT}:patientStatusPage.statusAdditionInfo.optional`);
            } else if (!item.createdAt) {
              return null;
            }
            return moment(item.createdAt).format('DD/MMM/YYYY');
          };
          return (
            <ProgressItem
              key={item.name}
              first={index === 0}
              optional={item.optional}
              skipped={item.skipped}
              current={item.current}
              failed={item.dropStatus}
              name={item.name}
              date={dateText()}
              notHappened={!item.createdAt}
              previousSkipped={progress[index - 1]?.skipped}
              previousFailed={progress[index - 1]?.dropStatus}
              previousOptional={progress[index - 1]?.optional}
              previousHappened={progress[index - 1]?.createdAt}
              addMissingStatus={addMissingStatus}
              displayAddButton={displayAddButton}
            />
          );
        })}
      </div>
    </>
  );
};

export default PatientStatusProgress;
